import React from "react";
import PropTypes from "prop-types";
import EditIcon from "assets/images/form/edit-icon.svg";
import DeactivateIcon from "assets/images/form/deactivate-icon.svg";
import ActivateIcon from "assets/images/form/activate-icon.png";
function LanguageActions({ data, props, viewType }) {
  const editLanguage = () => {
    if (data.is_active) props.editLanguage(data);
    else props.actionOnDeactivatedLanguage();
  };
  const deleteLanguage = async () => {
    props.deactivateLanguageConfirmation(data.id, data.is_active);
  };
  return (
    <div className="d-flex gap-3 table-actions">
      <img onClick={editLanguage} src={EditIcon} alt="edit-icon" />
      <img
        onClick={deleteLanguage}
        src={data.is_active ? DeactivateIcon : ActivateIcon}
        alt="edit-icon"
      />
    </div>
  );
}
LanguageActions.propTypes = {
  data: PropTypes.object,
  props: PropTypes.object,
  viewType: PropTypes.string,
};
export default LanguageActions;
